import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../../css/table.css';
import { get } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { IoEye } from 'react-icons/io5';
import SelectDropdown from '../../Common/SelectDropdown';
import { deleteRequest } from '../interceptor/interceptor';
import { newsTableHeader } from '../../Fields/newsFields';
import { REMOVE_BUDGET_NEWS } from '../../apiConst';
import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DeleteModal from '../../Common/DeleteModal';
import { MdDelete } from 'react-icons/md';
export default function NewsList({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
  onEdit,
  onView,
  onStepperForm,
  register,
  errors,
}) {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [searchVal, setSearchVal] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const headers = newsTableHeader;
  const { role } = useSelector((state) => state.user);
  const [modal, setModal] = useState(false);
  const [dataId, setDataId] = useState('');
  const [moduleId, setModuleId] = useState('');
  const handleChangePage = async (event, newPage) => {
    console.log('new page: ' + newPage);
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage, '');
  };

  const handleChangeRowsPerPage = (event) => {
    console.log('event' + event.target.value);
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value), '');
  };

  const handleSearchFieldDropdown = (e) => {
    if (searchVal) {
      getListData(1, rowsPerPage, searchVal, e.target.value);
    }
  };

  const openModal = (item) => {
    setModal(true);
    setDataId(item?.newsId);
    setModuleId(item?.type);
  };

  const onDelete = (id) => {
    console.log('id: ' + id);
    setIsLoading(true);
    deleteRequest(`${REMOVE_BUDGET_NEWS}module=${moduleId}&id=${id}`)
      .then((res) => {
        setModal(false);
        setIsLoading(false);
        toast.success('News Item Deleted Successfully');
        getListData();
      })
      .catch((error) => {
        setModal(false);
        console.log('error', error);
        setIsLoading(false);
      });
  };

  const componentDisplay = () => {
    const cells = headers?.filter(
      (cell) =>
        cell.id === 'newsId' ||
        cell.id === 'news' ||
        cell.id === 'title' ||
        cell.id === 'source' ||
        cell.id === 'link'
    );
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-96">
        <DeleteModal
          dataId={dataId}
          firstButtonText={'Cancel'}
          secondButtonText={'Delete'}
          heading={'Confirm Delete'}
          body={<p>Do you want to remove the news?</p>}
          modal={modal}
          pressSecondButton={(id) => onDelete(id)}
          pressFirstButton={() => setModal(false)}
          pressCloseButton={() => setModal(false)}
        />
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-3 w-48 border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={0}
                searchVal={searchVal}
                headingText={'News Details'}
                order={order}
                searchBar={true}
                orderBy={orderBy}
                rowCount={tableRowsData.length || 0}
                tableRowsData={tableRowsData}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getListData}
                componentDisplay={componentDisplay}
              >
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  tableRowsData.map((data) => (
                    <TableCard
                      key={data.newsId}
                      newsId={data.newsId}
                      title={data.title}
                      description={data?.description}
                      link={data?.link}
                      status={data.status}
                      type={data.type}
                      allowedRoles={['Super-Admin', 'Admin', 'editor']}
                      role={role}
                      onEdit={
                        role === 'Super-Admin' ||
                        role === 'Admin' ||
                        role === 'editor'
                          ? (e) => onStepperForm(data, e)
                          : undefined
                      }
                      onView={
                        role === 'Super-Admin' ||
                        role === 'Admin' ||
                        role === 'editor'
                          ? (e) => onStepperForm(data, e)
                          : undefined
                      }
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Entries per page: '}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div style={{ width: '100%' }}>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              headingText={'News Details'}
              order={order}
              searchBar={true}
              orderBy={orderBy}
              rowCount={tableRowsData.length || 0}
              tableRowsData={tableRowsData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getListData}
              componentDisplay={componentDisplay}
            >
              <TableBody className="table-body">
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  stableSort(tableRowsData, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={index}>
                          {headers.map((cell) => {
                            return (
                              <TableCell key={cell.id + index} className={cell.id === 'sno' ? 'sno-column' : ''}>
                                {cell.id === 'action' ? (
                                  <div className="justify-around items-center flex">
                                    {/* <div onClick={(e) => onEdit(row)}>
                                      <FaEdit size={20}/>
                                    </div> */}
                                    <div
                                      onClick={(e) => {
                                        if (role !== 'user') {
                                          onView(row, e);
                                        }
                                      }}
                                      style={{
                                        pointerEvents:
                                          role === 'user' ? 'none' : 'auto',
                                        opacity: role === 'user' ? 0.5 : 1,
                                      }}
                                    >
                                      <IoEye
                                        size={23}
                                        className="cursor-pointer text-blue-600 hover:text-blue-800 transition"
                                      />
                                    </div>
                                    {role === 'Super-Admin' && (
                                      <div onClick={(e) => openModal(row)}>
                                        <MdDelete
                                          size={25}
                                          className="cursor-pointer text-red-600 hover:text-red-800 transition"
                                        />
                                      </div>
                                    )}
                                  </div>
                                ) : cell.id === 'sno' ? (
                                  index + 1
                                ) : cell.id === 'newsId' ? (
                                  <div
                                    className="text-xs flex cursor-pointer text-blue-800 hover:font-bold"
                                    // style={{
                                    //   pointerEvents:
                                    //     role === 'user' ? 'none' : 'auto',
                                    //   // opacity: role === "user" ? 0.5 : 1,
                                    // }}
                                  >
                                    <div
                                      onClick={(e) =>
                                        role !== 'user' && onStepperForm(row, e)
                                      }
                                    >
                                      {get(row, cell.id)}
                                    </div>
                                  </div>
                                ) : cell.id === 'status' ? (
                                  <div
                                    className={`justify-center flex capitalize
                                     hover:font-bold`}
                                  >
                                    {get(row, cell.id) === 'inprogress'
                                      ? 'In Progress'
                                      : get(row, cell.id)}
                                  </div>
                                ) : (
                                  <Tooltip title={get(row, cell.id)}>
                                    <span>
                                      {get(row, cell.id)?.length > 30
                                        ? `${get(row, cell.id)?.slice(
                                            0,
                                            30
                                          )}...`
                                        : get(row, cell.id)}
                                    </span>
                                  </Tooltip>
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={'Entries per page: '}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
